import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SocialProofBar() {
  return <FadeIn data-id="element-289">
      <div className="w-full bg-gray-900 border-y border-gray-800 py-6" data-id="element-290">
        <div className="max-w-5xl mx-auto px-4 flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-center font-medium" data-id="element-291">
          <div className="text-lg text-gray-300" data-id="element-292">+500 estudiantes</div>
          <div className="hidden sm:block text-gray-600" data-id="element-293">•</div>
          <div className="text-lg text-gray-300" data-id="element-294">6 Tomos</div>
          <div className="hidden sm:block text-gray-600" data-id="element-295">•</div>
          <div className="text-lg text-gray-300" data-id="element-296">6 Bonos</div>
          <div className="hidden sm:block text-gray-600" data-id="element-297">•</div>
          <div className="flex items-center gap-1 text-lg text-gray-300" data-id="element-298">
            4,9/5
            <div className="flex text-yellow-400 ml-1" data-id="element-299">
              <Star size={18} fill="currentColor" data-id="element-300" />
            </div>
          </div>
        </div>
      </div>
    </FadeIn>;
}